const localization_toggle = (container) => {
  const element = container; // Questo è l'elemento su cui è stato fatto il click
  const control = element.getAttribute('aria-controls');
  const popoverControl = document.getElementById(control);
  const isExpanded = element.getAttribute('aria-expanded');
  console.log(control, popoverControl, isExpanded);

  if (isExpanded === 'true') {
    element.setAttribute('aria-expanded', 'false');
    popoverControl.setAttribute('aria-hidden', 'true');
  } else {
    element.setAttribute('aria-expanded', 'true');
    popoverControl.setAttribute('aria-hidden', 'false');
  }
}

const localizationLanguageMobile = document.getElementById('lang-sidebar');
localizationLanguageMobile.addEventListener('click', () => localization_toggle(localizationLanguageMobile));

const localizationCountryMobile = document.getElementById('currency-sidebar');
localizationCountryMobile.addEventListener('click', () => localization_toggle(localizationCountryMobile));

const iconCloseLanguageMobile = document.getElementById('icon-close-language-js');
iconCloseLanguageMobile.addEventListener('click', () => localization_toggle(localizationLanguageMobile));

const iconCloseCurrencyMobile = document.getElementById('icon-close-currency-js');
iconCloseCurrencyMobile.addEventListener('click', () => localization_toggle(localizationCountryMobile));